import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "4",
  cy: "4",
  r: "3"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]



	// eslint-disable-next-line
	
export default /*#__PURE__*/_defineComponent({
  __name: 'TwBadge',
  props: { 
		color: {
			type: String,
			default: 'brand'
		},
		dot: {
			type: Boolean,
			default: false
		},
		large: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex items-center rounded-full py-1 font-medium", [`bg-${__props.color}-100 text-${__props.color}-800`, __props.large ? 'px-3 text-sm' : 'px-2.5 text-xs']])
  }, [
    (__props.dot)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: _normalizeClass(["-ml-0.5 mr-1.5 h-2 w-2", `text-${__props.color}-400`]),
          fill: "currentColor",
          viewBox: "0 0 8 8"
        }, _hoisted_2, 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})